import React from 'react';
import { buttonReset, color, font, FONT_FAMILY, radius, shadow, space, TAP } from '../theme';
import Icon from './Icon';

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  // Accessible name; defaults to the placeholder
  label?: string;
  // 'raised' sits on the page background; 'flat' sits inside a card
  variant?: 'raised' | 'flat';
  // Optional control at the far end, e.g. a filter button
  trailing?: React.ReactNode;
  autoFocus?: boolean;
  style?: React.CSSProperties;
  // For a combobox (GlobalSearch): a ref to the input, and ARIA and key/focus handlers on it
  inputRef?: React.Ref<HTMLInputElement>;
  inputProps?: Omit<React.InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'style' | 'type'>;
}

const SearchField = ({ value, onChange, placeholder, label, variant = 'raised', trailing, autoFocus, style, inputRef, inputProps }: SearchFieldProps) => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    gap: space.sm,
    minHeight: TAP,
    padding: `0 ${space.xs}px 0 ${space.md + 2}px`,
    borderRadius: radius.lg,
    background: variant === 'flat' ? color.surfaceMuted : color.surface,
    boxShadow: variant === 'raised' ? shadow.raised : 'none',
    color: color.textTertiary,
    ...style,
  }}>
    <Icon name="search" size={18} strokeWidth={2} />
    {/* type="text" rather than "search", so the browser doesn't add a second clear button */}
    <input
      ref={inputRef}
      {...inputProps}
      type="text"
      inputMode="search"
      enterKeyHint="search"
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      aria-label={label || placeholder}
      autoFocus={autoFocus}
      style={{
        flex: 1,
        minWidth: 0,
        height: TAP,
        border: 0,
        outline: 'none',
        background: 'transparent',
        fontFamily: FONT_FAMILY,
        fontSize: font.body,
        color: color.text,
      }}
    />
    {value && (
      <button
        type="button"
        onClick={() => onChange('')}
        aria-label="ניקוי החיפוש"
        style={{ ...buttonReset, width: TAP, height: TAP, display: 'flex', alignItems: 'center', justifyContent: 'center', color: color.textSecondary }}
      >
        <Icon name="close" size={18} />
      </button>
    )}
    {trailing}
  </div>
);

export default SearchField;
